<template>
  <div class="animated fadeIn">
    <b-row>
      
      <b-col lg="12" style="overflow-x:scroll;">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">{{ $t("diets.name") }}</th>
              <th scope="col">{{ $t("diets.text") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="diet in diets[language]">
              <td>
                {{diet.name}}
              </td>
              <td>
                {{diet.description}}
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import InfoService from '@/services/info.service.js';

export default {
  name: 'diet-types',
  data: function () {
    return {
      diets: { en: [], iw: [] }
    }
  },
  created() {
    
    InfoService.getDietTypes().then((res)=>{
      if(res.data.success){
        res.data.dietTypes.forEach((diet)=>{
          this.diets.en.push({ name : diet.name_en, description : diet.description_en});
          this.diets.iw.push({ name : diet.name_iw, description : diet.description_iw});
        });
      }else{
        alert("ERROR");
      }
    },err => {
      alert("ERROR");
    });
    
  },
  computed: {
    language() {
        return this.$store.getters['UserModules/getLanguage']
    }
  },
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
